import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const GlobalControlReport = lazy(() =>
  import("@scenes/GlobalControl").then((module) => ({
    default: module.PermissionGatedKpiReport,
  }))
);

export const globalControlReportNRO: NavigationRoutingObject = {
  Component: GlobalControlReport,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("global-control-report-sidebar-pill-menu-option", "Global Control Group Report"),
  pageNameForTracking: () => "Global Control Group Report",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("global-control", "Global Control")],
      description: t("previously-global-control", 'Previously "Global Control"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
